import type { Hall } from '../api/types';
import type { Key } from '../i18n';

/**
 * The lowest price a venue actually sells at, and the unit it is for.
 *
 * Per hour only when the venue takes hourly bookings and charges for them;
 * otherwise its half-day, then its day rate. A full-day-only venue used to
 * show "Rs 0 / hour". null when the venue has no price at all.
 */
export function startingPrice(
  hall: Pick<Hall, 'allow_hourly' | 'hourly_price' | 'halfday_price' | 'fullday_price'>,
): { amount: number; unit: Key } | null {
  if (hall.allow_hourly && hall.hourly_price > 0) return { amount: hall.hourly_price, unit: 'priceUnitHour' };
  if (hall.halfday_price > 0) return { amount: hall.halfday_price, unit: 'priceUnitHalfDay' };
  if (hall.fullday_price > 0) return { amount: hall.fullday_price, unit: 'priceUnitDay' };
  return null;
}
